import { useEffect, useState } from "react";
import { MessageCircle, X, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { ThreadView } from "@/components/support/ThreadView";
import { NewThreadForm } from "@/components/support/NewThreadForm";

export const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const [thread, setThread] = useState(null);
  const [unread, setUnread] = useState(false);
  const [fresh, setFresh] = useState(false);
  const load = () => api.get("/support/threads", { params: { kind: "CHAT" } }).then((r) => {
    const t = r.data.find((x) => x.status !== "CLOSED");
    setThread(t || null);
    setUnread(!!t?.unread_user);
  }).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);

  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3">
      {open && (
        <div className="w-80 sm:w-96 h-[460px] bg-white rounded-2xl shadow-2xl border flex flex-col overflow-hidden" data-testid="chat-panel">
          <div className="bg-slate-900 text-white px-4 py-3 flex items-center justify-between">
            <div><div className="font-semibold text-sm">Canlı destek</div><div className="text-[11px] text-slate-300">EmlakPro destek ekibi size yardımcı olur</div></div>
            <div className="flex gap-1">
              {thread && <button title="Yeni sohbet" data-testid="chat-new-btn" onClick={() => { setThread(null); setFresh(true); }} className="p-1 hover:bg-white/10 rounded"><Plus className="w-4 h-4" /></button>}
              <button data-testid="chat-close-btn" onClick={() => setOpen(false)} className="p-1 hover:bg-white/10 rounded"><X className="w-4 h-4" /></button>
            </div>
          </div>
          <div className="flex-1 min-h-0">
            {thread && !fresh ? <ThreadView threadId={thread.id} /> : (
              <div className="overflow-y-auto h-full">
                <p className="px-3 pt-3 text-xs text-slate-500">Bilgilerinizi girip mesajınızı yazın; destek ekibimiz bu pencereden yanıt verir.</p>
                <NewThreadForm kind="CHAT" prefix="chat" onCreated={(t) => { setFresh(false); setThread(t); }} />
              </div>
            )}
          </div>
        </div>
      )}
      <button data-testid="chat-launcher" onClick={() => { setOpen(!open); setUnread(false); }}
        className="relative w-14 h-14 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white shadow-lg flex items-center justify-center transition-transform hover:scale-105">
        {open ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
        {unread && !open && <span data-testid="chat-unread-dot" className="absolute top-0 right-0 w-3.5 h-3.5 rounded-full bg-red-500 border-2 border-white" />}
      </button>
    </div>
  );
};
